import { HIP } from '@eab-eip/hi-hip/hi-hif';
import { html } from 'lit-html';
import { ifDefined } from 'lit-html/directives/if-defined.js';

import f1 from '@eab-pip/pi-f1';

const entity = 'dashboard';
const chartTypes = [
  'bar',
  'min-bar',
  'line',
  'min-line',
  'pie',
  'min-pie',
  'doughnut',
  'min-doughnut',
  'area',
  'min-area'
];

chartTypes.forEach((render_type) => {
  HIP.visitor.add({
    entity,
    render_type: render_type,
    build: (fieldType: Record<string, unknown>, builderEl: Element & { ns: string }) => {
      const hrf = !f1.is.empty(f1.read(f1.lens(`/report/render/${fieldType.name}`), {}, builderEl))
        ? f1.read(f1.lens(`/report/render/${fieldType.name}`), {}, builderEl)
        : f1.read(f1.lens(`/report/${fieldType.name}`), {}, builderEl);

      const uniqueId = fieldType.name;
      const nameSpace = builderEl.ns;
      const width = ifDefined(f1.read('/$configure/chart/width', undefined, fieldType));
      const height = ifDefined(f1.read('/$configure/chart/height', undefined, fieldType));
      return html`
        <div style="margin-top:1em;" ns="${nameSpace}">
          <vi-chart
            id="${uniqueId}"
            gid="${uniqueId}"
            kind="${render_type}"
            library="chart"
            .input="${hrf}"
            width="${width}"
            height="${height}"
            ns="${nameSpace}"
            allow-toggle
          >
          </vi-chart>
        </div>
      `;
    }
  });
});
